import { render } from "./ChamberConfigs.vue?vue&type=template&id=ccfb3cb0&ts=true"
import script from "./ChamberConfigs.vue?vue&type=script&lang=ts"
export * from "./ChamberConfigs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__